
import React, { createContext, useState } from "react";
import Proptypes from 'prop-types';

const SmsContext = createContext();

const SmsProvider = ({ children }) => {
  const [sendingSms, setSendingSms] = useState([]);
  const [switchToUpdate, setSwitchToUpdate] = useState({});
  const [messageType, setMessageType] = useState('');
  const contextValue = {
    sendingSms, setSendingSms,
    switchToUpdate, setSwitchToUpdate,
    messageType, setMessageType
  };

  return (
    <SmsContext.Provider value={contextValue}>
      {children}
    </SmsContext.Provider>
  );
};

SmsProvider.propTypes = {
  children: Proptypes.element
}

export { SmsContext as default, SmsProvider };

